<template>
    <div>
        <div class="container mt-3">
            <b-card class="text-center">
                <b-row class="treasury-logo p-1" align-v="end">
                    <b-col cols="2">
                        <img class="p-1" src="~@/assets/images/grb.svg">
                    </b-col>
                    <b-col>
                        <div class="p-2">
                            <label>РЕПУБЛИКА СРБИЈА</label>
                            <label>МИНИСТАРСТВО ФИНАНСИЈА</label>
                            <label class="heavy-text">УПРАВА ЗА ТРЕЗОР</label>
                        </div>
                    </b-col>
                </b-row>
                <h3 class="mt-5 mb-3 heavier-text">Централни регистар фактура</h3>
                <br>

                <br>
                <p class="p-1">
                Министарство финансија спроводи мере и активности у вези са контролом преузетих обавеза у јавном сектору
                што између осталог подразумева евидентирање, праћење и извештавање о неизмиреним обавезама.
                За обављање поменутих активности успостављен је информациони систем под називом Централни регистар фактура (ЦРФ).
                </p>
                <br>
                <b-card bg-variant="warning" text-variant="white" class="text-center">
                  <b-card-text>
                     <span class="heavier-text"><b-link href='https://www.trezor.gov.rs/files/services/crf/Obave%C5%A1tenje%20subjektima%20javnog%20sektora%20koji%20pla%C4%87anja%20vr%C5%A1e%20preko%20ra%C4%8Duna%20koji%20se%20vode%20kod%20banaka%20-%2019.05.2026.%20godine.pdf'>Обавештење субјектима јавног сектора који плаћање врше преко рачуна који се воде код банака</b-link></span>
                  </b-card-text>
                </b-card>
                <hr>
                <p class="heavier-text" style="color: #aaaaaa;"> Погледајте <a style="color: gray;" href='/docs/user/register'>документацију за регистровање</a> правног лица</p>
            </b-card>
            <br>
            <b-row align-h="center" class="mt-3 heavier-text">
                <a :href="changelogPath">
                    <span>{{$t('general.changelog')}}</span>
                </a>
            </b-row>
            <b-row align-h="center" class="mt-5 heavier-text">
                <a :href="supportPath">
                    <span>{{$t('general.technicalSupport')}}</span>
                </a>
            </b-row>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { isUserActive, logout } from '@/router/auth'
  import { EventBus } from '@/router/bus'

  export default {
    name: 'startpage',
    data () {
      return {
        user: {},
        loginVisibility: 'none',
        loginError: false,
        connectionError: false,
        changelogPath: '',
        supportPath: '',
        integrationPath: ''
      }
    },
    created () {
      if (isUserActive()) {
        this.$router.push('/dashboard')
      } else {
        logout()
        EventBus.$emit('logged-out', '')
      }

      this.changelogPath = (Vue.$config.help_root + '/changelog/').replace(/([^:]\/)\/+/g, '$1')
      this.supportPath = (Vue.$config.help_root + '/support/').replace(/([^:]\/)\/+/g, '$1')
      this.integrationPath = (Vue.$config.help_root + '/integration/').replace(/([^:]\/)\/+/g, '$1')
    },
    methods: {
      register: function (e) {
        this.$router.push('/register')
      }
    }
  }

</script>

<style lang="scss">
    /*@import '../assets/css/login.scss';*/
    // @import '../assets/scss/main.scss';

    .treasury-logo {
        height: 75px;
        width: 260px;
        margin: 0 auto;
        img {
            width: 55px;
            height: 75px;
        }
        label {
            display: block;
            font-size: 8pt;
            font-weight: 600;
            margin: 0px;
        }
    }

    .heavy-text {
        font-weight: 800 !important;
    }

    .heavier-text {
        font-weight: 600;
    }

</style>



// WEBPACK FOOTER //
// StartPage.vue?953ad8b4